import React, {useEffect, useState} from 'react';
import {Router, Switch, Route} from 'react-router-dom';
import history from './utils/history'
import Homepage from "./pages/homepage";


export default function App(props) {
    const [config, setConfig] = useState({});

    useEffect(() => {
        setConfig(props.config[window.location.hostname]);
    }, [window.location.hostname]);

    return (
        <Router history={history}>
            <Switch>
                <Route exact path="/" component={() => <Homepage config={config}/>}/>
                <Route exact path="/partners/:partner_name_param" component={() => <Homepage config={config}/>}/>
            </Switch>
        </Router>
    );
}

